import {
  ClientOptions,
  FeatureFlagsClient,
  FlagBaseContext,
  Team,
} from '@getvim/feature-flags/client';
import { createFeatureFlagContext } from '@getvim/feature-flags/react';
import { isEmpty, trim } from 'lodash-es';

interface EligibilityFlagContext extends FlagBaseContext {
  organizationId?: number;
}

const {
  rollout__key: rolloutKey,
  VIM_feature_flags__proxy_url: proxyUrl,
  VIM_feature_flags__unify_key: unifyKey,
} = globalThis.$vim_environment ?? {};

const ffClientOptions: ClientOptions<EligibilityFlagContext> = {
  team: Team.PatientInsights,
  namespace: 'eligibility',
  rolloutKey,
  proxyUrl,
  unifyKey: isEmpty(trim(unifyKey)) ? undefined : unifyKey,
  defaultContext: {},
};

const { FeatureFlagProvider, useFeatureFlag } = createFeatureFlagContext<EligibilityFlagContext>();

// Initialize the singleton at module load so SDK init finishes before the first hook call
const featureFlagsClient = FeatureFlagsClient.getInstance<EligibilityFlagContext>(ffClientOptions);

export { featureFlagsClient, FeatureFlagProvider, ffClientOptions, useFeatureFlag };

export { Team } from '@getvim/feature-flags/client';
